let utils = {
    checkPass: {
        msg01: "密码最少",
        msg02: "位,最多",
        msg03: "位",
        msg04: "至少包含数字、大写字母、小写字母和特殊字符中的其中的3种",
        msg05: "必须包含数字、大写字母、小写字母和特殊字符",
        msg06: "同一字符出现次数不超过",
        msg07: "次",
        msg08: "密码中不能包含用户名",
        msg09: "密码中不能包含手机号",
        msg10: "密码不能包含邮箱前缀",
        msg11: "密码中不能包含用户名倒写",
    },
    checkPwd: {
        msg: "校验通过"
    },
}

export default utils